
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryConfigurationMasterGroups, QueryConfigurationMasterGroupsResponse, ConfigurationMasterGroup } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QueryConfigurationMasterGroupsResponse, QueryConfigurationMasterGroupsResponse>) => response?.data?.data?.find(x => true);
const getError = (response?: SWRResponse<QueryConfigurationMasterGroupsResponse, QueryConfigurationMasterGroupsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QueryConfigurationMasterGroupsResponse, QueryConfigurationMasterGroupsResponse>) => ({});

export const useConfigurationMasterGroup = (query?: Partial<ConfigurationMasterGroup>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new QueryConfigurationMasterGroups(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationMasterGroup;